module.exports = __webpack_public_path__ + "ced32f47d41d0f4e7666a1df2c5572f1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg2-white-opacity.jpg
 ** module id = 207
 ** module chunks = 1
 **/